module.exports = __webpack_public_path__ + "static/media/scale.d260aa73.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/pic/scale.PNG
// module id = 512
// module chunks = 0